const getTaxonomy = (ID, taxonomies) => {

    let taxonomy = []
    taxonomies.forEach((terms) =>
        terms.forEach((term) => {
            if (term.id === ID) {
                taxonomy = term;
            }
        })
    )
    return taxonomy;
}

export default getTaxonomy;